module.exports = __webpack_public_path__ + "img/folder-blank.f7d5e402.svg";